import React, { FC }          from 'react';
import moment                 from 'moment';
import { CORVAL_ENTITY_NAME } from '../../../constants/SystemEnums';

const defaultProps = {};

const CorvalCopyright: FC = () => {
	
	return (
		<>&copy; { moment().format( 'YYYY' ) } { CORVAL_ENTITY_NAME }</>
	);
};

CorvalCopyright.defaultProps = defaultProps;

export { CorvalCopyright }
